<template>
  <v-form ref="form">
    <div class="fila-contrato">
      <div class="campo-container">
        <v-text-field
          v-model="fila.codigo"
          maxlength="10"
          label="Codigo"
          @input="$v.fila.codigo.$touch()"
          @blur="$v.fila.codigo.$touch()"
        ></v-text-field>
        <div
          v-if="
            $v.fila.codigo.$dirty &&
            !$v.fila.codigo.required &&
            !$v.fila.codigo.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "Código es obligatorio" }}
        </div>
        <div
          v-if="
            typeof $v.fila.codigo.maxLength !== 'boolean' &&
            $v.fila.codigo.maxLength &&
            !$v.fila.codigo.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "Código excede la longitud máxima" }}
        </div>
      </div>
      <div class="campo-container">
        <v-text-field
          v-model="fila.itemContrato"
          maxlength="50"
          label="Item"
          @input="$v.fila.itemContrato.$touch()"
          @blur="$v.fila.itemContrato.$touch()"
        ></v-text-field>
        <div
          v-if="
            $v.fila.itemContrato.$dirty &&
            !$v.fila.itemContrato.required &&
            !$v.fila.itemContrato.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "El ítem es obligatorio" }}
        </div>
        <div
          v-if="
            typeof $v.fila.itemContrato.maxLength !== 'boolean' &&
            $v.fila.itemContrato.maxLength &&
            !$v.fila.itemContrato.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "El ítem excede la longitud máxima" }}
        </div>
      </div>
      <div class="campo-container">
        <v-select
          v-model="fila.proceso"
          :items="procesoSelect"
          item-text="text"
          item-value="value"
          label="Proceso"
          @input="$v.fila.proceso.$touch()"
          @blur="$v.fila.proceso.$touch()"
        ></v-select>
        <div
          v-if="
            $v.fila.proceso.$dirty &&
            !$v.fila.proceso.required &&
            !$v.fila.proceso.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "Proceso es obligatorio" }}
        </div>
      </div>
      <div class="campo-container">
        <v-menu
          v-model="fila.menu1"
          :close-on-content-click="true"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              label="Fecha inicio contrato"
              prepend-icon="event"
              v-on="on"
              v-bind="attrs"
              v-model="fila.fechaInicioFormatted"
              @blur="fila.fechaInicio = parseDate(fila.fechaInicioFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fila.fechaInicio"
            @input="fila.menu1 = false"
            no-title
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <div
          v-if="
            $v.fila.fechaInicio.$dirty &&
            !$v.fila.fechaInicio.required &&
            !$v.fila.fechaInicio.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "Fecha de inicio es obligatoria" }}
        </div>
      </div>
      <div class="campo-container">
        <v-menu
          v-model="fila.menu2"
          :close-on-content-click="true"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              label="Fecha fin contrato"
              prepend-icon="event"
              v-on="on"
              v-bind="attrs"
              v-model="fila.fechaFinFormatted"
              @blur="fila.fechaFin = parseDate(fila.fechaFinFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fila.fechaFin"
            @input="fila.menu2 = false"
            no-title
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <div
          v-if="
            $v.fila.fechaFin.$dirty &&
            !$v.fila.fechaFin.required &&
            !$v.fila.fechaFin.$pending
          "
          class="v-messages theme--light error--text"
        >
          {{ "Fecha de fin es obligatoria" }}
        </div>
      </div>
      <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
        depressed
        outline
        icon
        fab
        dark
        color="red"
        small
        title="Eliminar contrato"
        @click="eliminarFila"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import jwtDecode from "jwt-decode";

export default {
  props: ["fila", "posicion", "procesoSelect"],
  mixins: [validationMixin],
  validations: {
    fila: {
      codigo: { required, maxLength: maxLength(10) },
      periodo: { required, maxLength: maxLength(4) },
      itemContrato: { required, maxLength: maxLength(50) },
      proceso: { required },
      fechaInicio: { required },
      fechaFin: { required },
    },
  },
  watch: {
    "fila.fechaFin"(newFechaFin) {
      this.fila.fechaFinFormatted = this.formatDate(newFechaFin);
    },
    "fila.fechaInicio"(newFechaInicio) {
      this.fila.fechaInicioFormatted = this.formatDate(newFechaInicio);
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    eliminarFila() {
      this.$emit("eliminar-fila");
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.fila-contrato {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #ccc;
}
.error-message {
  color: red; /* Estilo de color de error */
  font-size: 12px; /* Ajusta el tamaño del texto de error según tus preferencias */
  margin-top: 5px; /* Espacio superior para separar el mensaje del campo */
}

/* Estilo para el contenedor de cada campo y su mensaje de error */
.campo-container {
  margin-bottom: 15px; /* Espacio inferior entre cada par de campo y mensaje de error */
}
</style>